module App

open Client.Domain
open Client.Model
open Client
open Index
open Elmish
open Elmish.HMR
open Elmish.Navigation
open Thoth.Elmish

#if DEBUG
open Elmish.Debug
#endif

Program.mkProgram initialModel update view
#if DEBUG
|> Program.withConsoleTrace
#endif
|> Program.toNavigable (UrlParser.parsePath Routing.parseRoute) urlUpdate
|> Toast.Program.withToast Toast.renderToastWithFulma
|> Program.withReactSynchronous "elmish-app"
#if DEBUG
|> Program.withDebugger
#endif
|> Program.run